import React from "react";

import { ReactComponent as ChatIcon } from "../../images/chat.svg";
import { ReactComponent as ChevronRightIcon } from "../../images/chevron-right.svg";
import { loadLocalUser } from "../Services/HWIframeBridge";
import { s360ConfigService } from "../Services/S360Config";

import "../LandingPage/LandingPageStyleSheet.css";

function NewConversationButton(props) {
  const startConversation = () => {
    if (
      s360ConfigService.thrioConfig?.chatInitRes?.workitemId &&
      s360ConfigService.config.newConversationStarted &&
      !s360ConfigService.config.showChannels
    ) {
      s360ConfigService.config.isNewConversation = true;
      const workitem = s360ConfigService.thrioConfig?.chatInitRes;
      // workitem.chatMessages =
      //   s360ConfigService.activeSessions[
      //     s360ConfigService.config.workitemId
      //   ]?.chatMessages;
      props.landingPageActions.resumeConversation(
        workitem,
        s360ConfigService.thrioConfig?.chatInitRes?.workitemId
      );
    } else {
      props.onStartChanelClick();
    }
    loadLocalUser();
  };

  return (
    <div>
      <div
        className="s360-new-conversation-tab"
        style={props.config?.customDesign?.newConversationTab}
      >
        <div
          className="s360-new-conversation-tab-text"
          style={
            props.config?.customDesign?.chatTranscriptInitialFormStartButton
          }
          onClick={
            props?.page === "channels"
              ? props.onStartChanelClick
              : startConversation
          }
        >
          <div>
            <ChatIcon
              fill={s360ConfigService.config?.configDetails?.primaryColor}
            />
            <div>{"Continue to live chat"}</div>
            {/* <div>
              {s360ConfigService.thrioConfig?.chatInitRes?.workitemId &&
              s360ConfigService.config.newConversationStarted
                ? "Resume Conversation"
                : props.config?.configDetails?.startChatText}
            </div> */}
          </div>
          <ChevronRightIcon />
        </div>
      </div>
    </div>
  );
}
export default NewConversationButton;
